import { useTranslations } from 'next-intl';
import React from 'react';

import { MessagesKey } from '@/types/translations.types';
import { cn } from '@/utils/styles.utils';

import styles from './ProductProperties.module.css';

interface Property {
  id: string;
  labelId: MessagesKey;
  value: string | React.ReactNode;
  hideLabelOnMobile?: boolean;
}

interface Props {
  properties: Property[];
  size?: 's' | 'm';
  // Change style for product page,gallery changes in future other section same
  product?: boolean;
}

export const ProductProperties = (props: Props) => {
  const t = useTranslations();
  const { properties, size = 'm', product } = props;

  return (
    <ul className="space-y-0.5">
      {properties.map((property) => (
        <li
          key={property.id}
          className={cn(
            'relative flex gap-1.5',
            {
              'pl-2': !product,
            },
            !product && styles.li,
          )}
        >
          <span
            className={cn('text-body-m text-text-grey-standard', {
              'text-body-s': size === 's',
              'max-[340px]:hidden': property.hideLabelOnMobile,
            })}
          >
            {t(property.labelId)}
          </span>

          <span
            className={cn('inline-flex text-body-m text-text-grey-dark', {
              'text-body-s': size === 's',
              'font-bold': product,
            })}
          >
            {property.value}
          </span>
        </li>
      ))}
    </ul>
  );
};
